// extracted by mini-css-extract-plugin
export default {"rating":"WD-z","numberOfStars":"XD-z","count":"YD-z","barGraphSpacing":"ZD-z","barGraph":"_D-z"};